import type { PlaybookUsageQuery$variables } from '@atlassian/jira-relay/src/__generated__/PlaybookUsageQuery.graphql';
import PlaybookUsageQuery$parameters from '@atlassian/jira-relay/src/__generated__/PlaybookUsageQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const playbookUsageEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-playbooks-usage" */ './PlaybookUsage').then(
			(module) => module.PlaybookUsage,
		),
	),
	getPreloadProps: (variables: PlaybookUsageQuery$variables) => {
		return {
			queries: {
				PlaybookUsageQuery: {
					parameters: PlaybookUsageQuery$parameters,
					variables,
				},
			},
		};
	},
});
